import React, { useEffect,Suspense } from "react";
//import styles from './styles'
import { Scrollbars } from 'rc-scrollbars';
import { isMobile } from 'react-device-detect';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Image,
  Box,
  Flex,
  Stack,
  Spacer,
  Skeleton
} from '@chakra-ui/react'
import { useSelector } from 'react-redux';
import { useInjectSaga } from '../injectSaga';
import saga from './saga';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useToastHook } from "./myToast";
import { setApiKey,setCustomerCode } from "./actions";
import { useDispatch } from 'react-redux';

import configuration from '../services/configuration';
import { Mixpanel,trackStrings } from '../services/mixpanel';

const Register = React.lazy(() => import('../Register'));
const User = React.lazy(() => import('../User'));
const Offers = React.lazy(() => import('../Offers'));
const Document = React.lazy(() => import('../Document'));

const Emandate = React.lazy(() => import('../Emandate'));
const EmandateList = React.lazy(() => import('../Emandate/list'));
const EmandateSuccess = React.lazy(() => import('../Emandate/Success'));
const EmandatePhy = React.lazy(() => import('../Emandate/Phy'));
const EmandatePhyUpload = React.lazy(() => import('../Emandate/PhyUpload'));
const EmandateCallback = React.lazy(() => import('../Emandate/CallBackPage'));

const Esign = React.lazy(() => import('../Esign'));
const EsignPage = React.lazy(() => import('../Esign/page'));
const EsignEmail = React.lazy(() => import('../Esign/email'));
const EsignCallBack = React.lazy(() => import('../Esign/CallBackPage'));

const Success = React.lazy(() => import('../Success'));

const PageLoader = () => {
  return(
    <Stack mt="5">  
      <Skeleton height='15px' />
      <Skeleton height='15px' />
      <Skeleton height='15px' />
      <Spacer />
      <Skeleton height='15px' />
      <Skeleton height='15px' />
      <Skeleton height='15px' />
      <Spacer />
      <Skeleton height='15px' />
      <Skeleton height='15px' />
      <Skeleton height='15px' />
    </Stack>
  )
}

function App({defaultdata}) {
  useInjectSaga({ key: 'app', saga });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const elementRef = React.useRef();
  const [stateToast, newToast] = useToastHook();
  const [boxHe,setBoxHe] = React.useState(0)
  const {onboardingStep,myToasst,apiKey,custCode} = useSelector(state => state.app ?? []);

  const imageList= ["RivJskY7vAxnKWoA","3Yzpcns3CBAyV5dhTUanCLRfxtL9MNBA"/*,"A9xUJaPXjbUe1uAYTGBUUf3WqGXKc6nJ","fhZvui1svqLebYvHHRyEW1SusRnsY9Vd","yEEKb7V8MQVMcm8Qi8RhW4qCbmQsF414"*/];
  
  const dispatch = useDispatch();

  useEffect(()=> {
    if(elementRef && elementRef.current){
      elementRef.current.scrollTop()
    }    
  },[onboardingStep])

  useEffect(() => {
      newToast(myToasst);
  },[myToasst])

  useEffect(() => {
      if(window.innerHeight) {
        setBoxHe(isMobile ? window.innerHeight : window.innerHeight-150);
      }
  },[window])

  useEffect(() => {
      
      Mixpanel.track(trackStrings.VISITED_APP_SCREEN);
      
      function handleResize() {
        setBoxHe(isMobile ? window.innerHeight : window.innerHeight-150);
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener("resize", handleResize);
  },[])

  useEffect(() => {

    if(defaultdata && defaultdata.button !== undefined && defaultdata.button === false) {
      onOpen();
    }

    if(!apiKey && defaultdata.apiKey) {
      dispatch(setApiKey(defaultdata.apiKey));
    }

    if(!custCode && defaultdata.customerCode) {
      dispatch(setCustomerCode(defaultdata.customerCode));
    }

    if(defaultdata) {
      Mixpanel.track(trackStrings.DEFAULTDATA_APP_SCREEN, {
        defaultdata: defaultdata
      });
    }

  },[defaultdata])

   return (
    <div>
    {defaultdata && defaultdata.button !== false &&
      <Button colorScheme='veryLightBlue' onClick={onOpen} >Apply Now</Button>
    }
      
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={isMobile ? "full" : "md"}
        scrollBehavior="inside"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pt="2" pb="2" boxShadow="1px -2px 5px #9d9797">
          <Flex>
            <Box width="100%" display="flex" justifyContent="space-between">
              <Image width="125px" src='https://mintifi.com/img/logo.svg' alt='Dan Abramov' />
              {imageList.indexOf(apiKey) !== -1 &&
                <Image height="35px" style={{maxWidth: "150px"}} src={"/anchor/"+apiKey+".png"} />
              }              
            </Box>
          </Flex>
          </ModalHeader>
          {defaultdata && defaultdata.button !== false &&
            <ModalCloseButton />
          }
           <ModalBody p="0" overflow="hidden">
              <Scrollbars  ref={elementRef} autoHeight autoHide autoHeightMin={boxHe}>
              <Box px={isMobile ? "3":"6"} mb="10">
                {onboardingStep === "COMPANY" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Register urlDefaultData={defaultdata} />
                  </Suspense>
                }
                {onboardingStep === "DIRECTOR" && 
                  <Suspense fallback={<PageLoader/>}>
                    <User/>
                  </Suspense>
                }
                {onboardingStep === "OFFER" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Offers/>
                  </Suspense>
                }
                {onboardingStep === "DOCUMENT" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Document/>
                  </Suspense>
                }
                {onboardingStep === "BANK_ACCOUNT" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Emandate/>
                  </Suspense>
                }
                {onboardingStep === "ESIGN" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Esign/>
                  </Suspense>
                }
                {onboardingStep === "EMANDATE" && 
                  <Suspense fallback={<PageLoader/>}>
                    <EmandateList/>
                  </Suspense>
                }
                {onboardingStep === "EMANDATE_PHY_SUCCESS" && 
                  <Suspense fallback={<PageLoader/>}>
                    <EmandatePhy/>
                  </Suspense>
                }
                {onboardingStep === "EMANDATE_PHY_UPLOAD" && 
                  <Suspense fallback={<PageLoader/>}>
                    <EmandatePhyUpload/>
                  </Suspense>
                }                
                {onboardingStep === "EMANDATE_SUCCESS" && 
                  <Suspense fallback={<PageLoader/>}>
                    <EmandateSuccess/>
                  </Suspense>
                }
                {onboardingStep === "SUCCESS" && 
                  <Suspense fallback={<PageLoader/>}>
                    <Success/>
                  </Suspense>
                }
              </Box>
              </Scrollbars>
          </ModalBody>
        </ModalContent>
      </Modal>

    </div>
    );
}

function DeAPP(propsData) {

  if (configuration.MIX_PANEL_TOKEN) {
    Mixpanel.init(configuration.MIX_PANEL_TOKEN);
    Mixpanel.reset();
  }

  return (
        <Router>
        <Switch>
          <Route
            exact
            path="/esign_popup"
            name="Esign Page"
            render={(props) => <Suspense fallback={<PageLoader/>}><EsignPage {...props} /></Suspense>}
          />
          <Route
            exact
            path="/esign_request"
            name="Esign"
            render={(props) => <Suspense fallback={<PageLoader/>}><EsignEmail {...props} /></Suspense>}
          />
          <Route
            exact
            path="/esign_callback"
            name="Esign Page"
            render={(props) => <Suspense fallback={<PageLoader/>}><EsignCallBack {...props} /></Suspense>}
          />
          <Route
            exact
            path="/emandate_callback"
            name="Emandate Page"
            render={(props) => <Suspense fallback={<PageLoader/>}><EmandateCallback {...props} /></Suspense>}
          />
          <Route
            path="/"
            name="Login Page"
            render={(props) => <App defaultdata={propsData.defaultdata} {...props} />}
          />
          </Switch>
        </Router>
   );
}

export default DeAPP;
